const filterColors = ({ value, selectors }) =>{
  $(`${ selectors.mainSlider}, ${ selectors.thumbSlider }`).slick('slickUnfilter');
  $(`${ selectors.mainSlider}, ${ selectors.thumbSlider }`).slick('slickFilter', `[data-alt="${value}"]`).slick('refresh');
  $(`${ selectors.mainSlider}, ${ selectors.thumbSlider }`).slick('slickGoTo', 0);
}
const initSlider = ({ selector, options }) => $(`${ selector }`).slick(options);
window.addEventListener('DOMContentLoaded', function(){
  const $colorSwatches = [...document.querySelectorAll('input[name="Color"]')];
 
  const selectors = {
    mainSlider:'.hc-main',
    thumbSlider:'.hc-thumbs'
  };
  let mainOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: false,
    infinite:true,
    adaptiveHeight: true,
    prevArrow:'<button class="slick-prev-custom splide__arrow splide__arrow--prev" type="button" aria-label="Go to last slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>',
    nextArrow:'<button class="slick-next-custom splide__arrow splide__arrow--next" type="button" aria-label="Next slide"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" width="40" height="40"><path d="m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z"></path></svg></button>'
  }
  let thumbOptions = {
    slidesToShow: 5,
    slidesToScroll: 1,
    dots: false,
    arrows:true,
    infinite:true
  }
  initSlider({ selector:selectors.mainSlider, options:mainOptions });
  initSlider({ selector:selectors.thumbSlider, options:thumbOptions });
  if($colorSwatches.length > 0 ){
     const { value } = $colorSwatches.find(color => color.checked );
  	filterColors({ value, selectors }) 
     $colorSwatches.forEach($swatch => {
    $swatch.addEventListener('click', function(){
      const { value } = this;
      filterColors({ value, selectors }) 
    })
  })
  }

 
  $(document).on('click','.slick-slide', function(){
    const { slickIndex } = $(this).data();
    $(`${selectors.mainSlider}`).slick('slickGoTo', slickIndex)
  })
})